import { Component, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  /** Azione irreversibile: la CTA diventa "Elimina" ed e' marcata in rosso. */
  destructive?: boolean;
}

@Component({
  selector: 'rev-receipts-confirm-dialog-component',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './receipts-confirm-dialog-component.html',
  styleUrl: './receipts-confirm-dialog-component.scss',
})
export class receiptsConfirmDialogComponent {
  readonly title: string;
  readonly message: string;
  readonly destructive: boolean;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) data?: ConfirmDialogData) {
    this.title = data?.title ?? "Confermi l'azione corrente";
    this.message = data?.message ?? 'Sei sicuro di voler procedere con questa azione?';
    this.destructive = data?.destructive ?? true;
  }
}
